import { Link} from 'react-router-dom';


const Splash = () => {
  return (
    <>
    <div className='splash_body'>
      <div className="splash_header">
        <span>나에게 가장 가까운</span>
        <span> 인생 미용실 찾기 </span>
        <div className="splash_logo">
        <img src='https://kimsikyoung.github.io/images/HaiRound/logo/hairound_Wlogo.png' width={255} height={77} alt='logo'></img>
        </div>
      </div>
      <div className="splash_text">
      <Link to="/Login" className='splash_text_box'>
      로그인              
      </Link>
      <Link to="/Login" className='splash_text_box'>
      회원가입              
      </Link>
      </div>
      <div className="splash_copy">
      Copyright &copy; hairound Corp. All rights reserved.
      </div>
    </div>
    </>
  )
};

export default Splash;